import { useSelector } from "react-redux";
import api, { makeOptions } from "@/services/api";

const useBoletos = () => {
  const { data: user } = useSelector(state => state.auth);

  async function fetchBoletos(params = {}) {
    try {
      const endpoint = "boletos";
      const { data: response } = await api.get(endpoint, {
        ...makeOptions(user),
        params
      });

      if (response.success) {
        return {
          data: response.data,
          paginator: response.paginator
        };
      }

      return {
        data: [],
        paginator: null
      };
    } catch (error) {
      console.error("Erro ao buscar boletos:", error);
      return {
        data: [],
        paginator: null
      };
    }
  }

  async function cancelBoleto(boletoId) {
    try {
      const endpoint = `boletos/${boletoId}`;
      const { data: response } = await api.delete(endpoint, makeOptions(user));

      if (response.success) {
        return { success: true };
      }

      return { success: false, message: response.message || "Erro ao cancelar boleto" };
    } catch (error) {
      console.error("Erro ao cancelar boleto:", error);
      return { success: false, message: "Erro ao cancelar boleto" };
    }
  }

  async function approveBoleto(boletoId) {
    try {
      const endpoint = "boletos/aprovar";
      const { data: response } = await api.post(endpoint, { boleto_ids: [boletoId] }, makeOptions(user));

      if (response.success) {
        return { success: true };
      }

      return { success: false, message: response.message || "Erro ao aprovar boleto" };
    } catch (error) {
      console.error("Erro ao aprovar boleto:", error);
      return { success: false, message: "Erro ao aprovar boleto" };
    }
  }

  async function approveAllBoletos() {
    try {
      const endpoint = "boletos/aprovar-todos";
      const { data: response } = await api.post(endpoint, {}, makeOptions(user));

      if (response.success) {
        return { success: true };
      }

      return { success: false, message: response.message || "Erro ao aprovar boletos" };
    } catch (error) {
      console.error("Erro ao aprovar todos os boletos:", error);
      return { success: false, message: "Erro ao aprovar boletos" };
    }
  }

  async function fetchEmpresaBoletos(empresaId) {
    try {
      const endpoint = `empresas/${empresaId}/boletos`;
      const { data: response } = await api.get(endpoint, makeOptions(user));

      if (response.success) {
        return {
          data: response.data,
          paginator: response.paginator
        };
      }

      return {
        data: [],
        paginator: null
      };
    } catch (error) {
      console.error("Erro ao buscar boletos da empresa:", error);
      return {
        data: [],
        paginator: null
      };
    }
  }

  async function createBoleto(boletoData) {
    try {
      const endpoint = "boletos";
      const { data: response } = await api.post(endpoint, boletoData, makeOptions(user));

      if (response.success) {
        return { success: true, data: response.data };
      }

      return { success: false, message: response.message || "Erro ao criar boleto" };
    } catch (error) {
      console.error("Erro ao criar boleto:", error);
      return { success: false, message: "Erro ao criar boleto" };
    }
  }

  return {
    fetchBoletos,
    fetchEmpresaBoletos,
    cancelBoleto,
    createBoleto,
    approveBoleto,
    approveAllBoletos
  };
};

export { useBoletos };
